<template>
  <div>
  <div class="batch-title">请选择考试批次</div>

  <div class="mainCon" :class="launchPlan ? '': 'launchPlan'" id="p1">
    <div class="content">
      <div class="batch-category">
        <div class="batch-second-title">进行中的批次 <el-button style="float: right;" v-if="isShowPlan" size="small" type="primary" plain v-show="!launchPlan" @click="launchPlan = true">展开</el-button> </div>
        <el-row :gutter="20" v-if="openPlanList.length > 0">
          <el-col :span="8" class="el-col-item" v-for="item in openPlanList" :key="item.planId">
            <div class="batch-item">
              <div class="batch-item-title" >
                <p :title="item.planName" style="word-wrap:break-word;"> {{ item.planName }}</p>
              </div>
              <div class="batch-item-time">
                报名截止时间：{{ item.endSign }}
              </div>
              <div class="batch-item-status">
                <span class="batch-item-label">当前状态：</span>
                <span class="batch-item-status-text" :class="[getPlanStatus(item.state)]">{{ item.state }}</span>
              </div>
              <div class="batch-item-status">
                <span class="batch-item-label">考试类型：</span>
                <span class="batch-item-status-text">{{ item.examTypeName }}</span>
              </div>
              <div class="click-btn">
                <el-button type="primary" round size="small" @click="go(item.planId)">点击进入</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
        <div v-else class="batch-second-title">暂无进行中的批次。</div>
        <div><el-button v-if="isShowPlan" style="float: right;" size="small" type="primary" plain v-show="launchPlan" @click="launchPlan = false">收起</el-button> </div>
      </div>
    </div>
  </div>

  <div class="mainCon" :class="launchHistory ? '': 'launchHistory'" id="p2">
    <div class="content">
      <div class="batch-category">
        <div class="batch-second-title">历史批次 <el-button v-if="isShowHistory" style="float: right;" size="small" type="primary" plain v-show="!launchHistory" @click="launchHistory = true">展开</el-button> </div>
        <el-row :gutter="20" v-if="historyPlanList.length > 0">
          <el-col :span="8" class="el-col-item" v-for="item in historyPlanList" :key="item.planId">
            <div class="batch-item">
              <div class="batch-item-title">
                {{ item.planName }}
              </div>
              <div class="batch-item-time">
                报名截止时间：{{ item.endSign }}
              </div>
              <div class="batch-item-status">
                <span class="batch-item-label">当前状态：</span>
                <span class="batch-item-status-text" :class="[getPlanStatus(item.state)]">
                  {{ item.state }}
                </span>
              </div>
              <div class="batch-item-status">
                <span class="batch-item-label">考试类型：</span>
                <span class="batch-item-status-text">{{ item.examTypeName }}</span>
              </div>
              <div class="click-btn">
                <el-button type="primary" round size="small" @click="go(item.planId)">点击进入</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
        <div v-else class="batch-second-title"> 暂无与您相关的历史批次信息。 </div>
        <div><el-button v-if="isShowHistory" style="float: right;" size="small" type="primary" plain v-show="launchHistory" @click="launchHistory = false">收起</el-button> </div>
      </div>
    </div>
  </div>

  <!-- <div class="specify" v-show="launchPlan || launchHistory">
    <a href="#p1"> <el-button type="primary" size="small" plain>查看进行中批次</el-button></a>
    <br />
    <a href="#p2"> <el-button type="primary" size="small" plain style="margin-top: 4px;">查看历史的批次</el-button></a>
  </div> -->

  </div>

</template>
<script>
import { getBatch } from "@/http/modules/student/batch";
export default {
  name: "batch",
  data() {
    return {
      openPlanList: [],
      historyPlanList: [],

      launchPlan: false,
      launchHistory: false,

      isShowPlan: false,
      isShowHistory: false,

    };
  },
  mounted() {
    this.getBatchList();
  },
  methods: {
    getBatchList() {
      getBatch().then((res) => {
        if (res.code === 1) {
          let allPlan = [...res.data.openPlanList, ...res.data.historyPlanList];
          if (allPlan.length <= 1) {
            let planId = allPlan.length === 1 ? allPlan[0].planId : "";
            this.go(planId);
          } else {
            this.openPlanList = res.data.openPlanList;
            this.isShowPlan = this.openPlanList.length > 6;
            this.historyPlanList = res.data.historyPlanList;
            this.isShowHistory = this.historyPlanList.length > 6;
          }
        }
      });
    },
    getPlanStatus(state) {
      const stateMap = {
        未报名: "",
        报名已提交: "green",
        审核通过: "green",
        审核不通过: "red",
        已缴费: "green",
        未缴费: "yellow",
        下载准考证: "green",
        去考试: "green",
        成绩已发布: "green",
        成绩未发布: "red",
        退费: "red",
      };
      return stateMap[state] || "";
    },
    go(planId) {
      //存储全局当前批次
      if (planId) {
        sessionStorage.setItem("planId", planId);
      }
      this.$router.push({
        name: "home",
        query: { cpwd: this.$route.query.cpwd },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.specify {
  width: 116px;
  position: fixed;
  bottom: 120px;
  right: 80px;
}

.mainCon {
  overflow: hidden;
  box-shadow: 5px 5px 10px rgba(196, 196, 196, .75);
}
.launchPlan {
  max-height: 508px;
}
.launchHistory {
  max-height: 508px;
}
.batch-title {
  // color: #2d2f33;
  color: #FFF;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}
.batch-category {
  margin-bottom: 40px;
}
.batch-second-title {
  line-height: 32px;
  height: 32px;
  color: #2d2f33;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}
.el-col-item {
  margin-bottom: 20px;
}
.batch-item {
  background: linear-gradient(180deg, #e6f0ff 0%, #f2f8ff 100%);
  padding: 16px;
  box-sizing: border-box;
  border-radius: 6px;
  height: 224px;
  .batch-item-title {
    font-size: 14px;
    font-weight: 600;
    color: #2d2f33;
    cursor: pointer;
    p{
      width: 300px;
      // white-space: nowrap;
      height: 40px;
      overflow: hidden;
      // white-space: nowrap;
      // text-overflow: ellipsis;
      word-wrap:break-word;
      word-break:normal; 
    }
  }
  // .batch-item-title p:hover {
  //     overflow: visible;
  //   }
  .batch-item-time,
  .batch-item-label {
    font-size: 13px;
    color: #737780;
    line-height: 18px;
    margin-top: 16px;
  }
  .batch-item-status {
    margin-top: 12px;
    .batch-item-status-text {
      color: #9299a6;
      font-size: 13px;
    }
    .batch-item-status-text.green {
      color: #1dbf60;
    }
    .batch-item-status-text.red {
      color: #fe5958;
    }
    .batch-item-status-text.yellow {
      color: #f27900;
    }
  }
  .click-btn {
    display: flex;
    justify-content: center;
    margin-top: 22px;
  }
}
</style>
